const FALLBACK_COUNTRY_CODE = 'US';

class CreditCard {
  constructor(creditCardJson) {
    const address = creditCardJson.address || {};
    this.creditCardId = creditCardJson.id;
    this.cardType = creditCardJson.card_type;
    this.cardholderName = creditCardJson.cardholder_name;
    this.expirationMonth = creditCardJson.expiration_month;
    this.expirationYear = creditCardJson.expiration_year;
    this.fullExpirationYear = creditCardJson.full_expiration_year;
    this.cardNumber = creditCardJson.card_number;
    this.cvv = creditCardJson.cvv;
    this.lastFour = creditCardJson.last_4;
    this.streetAddress = address.street_address;
    this.extendedAddress = address.extended_address;
    this.locality = address.locality;
    this.region = address.region;
    this.postalCode = address.postal_code;
    this.countryCode = address.country_code || FALLBACK_COUNTRY_CODE;
    this.cardSource = creditCardJson.card_source;
  }
}

module.exports = CreditCard;



// WEBPACK FOOTER //
// ./javascripts/components/credit_cards/credit_card.js